// Constants
export const PAYMENT_PROVIDERS = {
  CASH: 'cash',
  TRANSFER: 'transfer',
  CARD: 'card',
  // FLUTTERWAVE: 'flutterwave',
  // PAYSTACK: 'paystack',
};

// export const PAYMENT_PROVIDER_LABELS = {
//   CASH: 'cash',
//   TRANSFER: 'Bank Transfer',
//   CARD: 'card',
//   // FLUTTERWAVE: 'Fluterwave',
//   // PAYSTACK: 'Paystack',
// };

export const PAYMENT_PROVIDER_LABELS = {
  CASH: 'CASH',
  TRANSFER: 'TRANSFER',
  CARD: 'CARD',
};

export const PAYMENT_PROVIDER_LIST = [
  { value: PAYMENT_PROVIDERS.CASH, label: PAYMENT_PROVIDER_LABELS.CASH },
  { value: PAYMENT_PROVIDERS.TRANSFER, label: PAYMENT_PROVIDER_LABELS.TRANSFER },
  { value: PAYMENT_PROVIDERS.CARD, label: PAYMENT_PROVIDER_LABELS.CARD },
  // { value: PAYMENT_PROVIDERS.FLUTTERWAVE, label: PAYMENT_PROVIDER_LABELS.FLUTTERWAVE },
  // { value: PAYMENT_PROVIDERS.PAYSTACK, label: PAYMENT_PROVIDER_LABELS.PAYSTACK },
];


export const PAYMENT_CURRENCY_LIST = [
  { value: 'NGN', label: '₦ Naira', icon: ""  },
   { value: 'USD', label: '$ Dollar', icon: ""  },
    { value: 'GBP ', label: '£ Pounds Sterling', icon: ""  },
     { value: 'EUR ', label: '€ Euros', icon: ""  },
 
]
export const EXPENSE_PAYMENT_CURRENCY_LIST = [
  { value: 'ngn', label: '₦ Naira', icon: ""  },
]